import { render, staticRenderFns } from "./remainNew.vue?vue&type=template&id=927088f0&scoped=true&"
import script from "./remainNew.vue?vue&type=script&lang=js&"
export * from "./remainNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927088f0",
  null
  
)

export default component.exports